import React from 'react';

const NotificationSettingsWidgetHelp = () => (
  <div>
    <h2>Notification Settings</h2>
    <p>
      Use this matrix to decide which workflow events send notifications, which
      roles receive them, and which template ID each row should render. Expand
      an event to see per-role toggles, assign the desired template, and switch
      on email or bell alerts as needed.
    </p>
    <p>
      Expand Appeals to configure notifications when an appeal is lodged, kept unchanged, authorized for reconsideration,
      sent for reassessment, concluded or withdrawn. Use the event_message template variable for a short summary.
    </p>
    <p>
      The widget also stores the PATH sender email used for PATH-generated SES
      emails. That address is shared through runtime configuration so the admin
      dashboard and portal mailers stay aligned. Bell alerts raised from these
      settings appear in the admin shell and now show a heading timestamp in
      the viewer&apos;s browser timezone.
    </p>
    <p>
      Saved changes update the <code>notification_setting</code> table that the
      intake service reads before dispatching SES or secure-message copies, and
      the sender email persists in <code>iset_runtime_config</code>. Only rows
      you modify are posted back to the API, so flip the Save and Cancel
      buttons to control when new settings take effect.
    </p>
  </div>
);

export default NotificationSettingsWidgetHelp;
